// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".theme-switcher{color:var(--body);background:transparent;border:0;padding:8px;display:flex;border-radius:8px;cursor:pointer}.theme-switcher:hover{background:var(--background-2)}.theme-switcher__icon{height:1.25rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
